import { SearchIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { formatShortcut } from '@gokrew/ui/utility/shortcuts';
import { TranslationNS } from '@/constants/translation-namespaces';
import { useCommandPalette } from '@/context/useCommandPaletteContext';

/** The header's way in to the palette, for anyone who does not know ⌘K. */
export const CommandPaletteButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation(TranslationNS.Common);
  const { setOpen } = useCommandPalette();
  const label = `${t('command_palette.open_label')} (${formatShortcut(['mod', 'K'])})`;
  return (
    <button
      type="button"
      className={className}
      onClick={() => setOpen(true)}
      aria-label={label}
      title={label}
    >
      <SearchIcon size={18} />
    </button>
  );
};
